import { render, staticRenderFns } from "./EmployeeSideBar.vue?vue&type=template&id=6b21a0f6"
import script from "./EmployeeSideBar.vue?vue&type=script&lang=js"
export * from "./EmployeeSideBar.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSideBar.vue?vue&type=style&index=0&id=6b21a0f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports